<template>
  <div>
    <el-pagination
        align="right"
        :background="background"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :layout="layout"
        :page-sizes="pageSizes"
        :total="total"
        v-bind="$attrs"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    total: { //总条数
      required: true,
      type: Number
    },
    page: { //页码
      type: Number,
      default: 1
    },
    limit: { //每页条数
      type: Number,
      default: 30
    },
    pageSizes: {
      type: Array,
      default() {
        return [20, 30, 50, 80]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        console.log(val)
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = 1
      this.$emit('pagination', {page: this.currentPage, limit: val})
    },
    handleCurrentChange(val) {
      console.log(val)
      this.$emit('pagination', {page: val, limit: this.pageSize})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pagination.vue